// flyHome Dashboard layouts
import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import RTL from "layouts/rtl";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import Police from "layouts/police";
import Listings from "layouts/listings";
import Coupons from "layouts/coupons";
import Franchise from "layouts/franchise";
import StatePage from "layouts/masterPage/statePage";
import CityPage from "layouts/masterPage/cityPage";
import LocationPage from "layouts/masterPage/locationPage";
import DistrictPage from "layouts/masterPage/districtPage";
import RoomTypePage from "layouts/masterPage/roomTypePage";
import BannerPage from "layouts/masterPage/bannerPage";
import AdvertisementPage from "layouts/masterPage/advertisementPage";
import CategoryPage from "layouts/masterPage/categoryPage";
import CmsContent from "layouts/cmsPage/cms";

import PoliceSignIn from "layouts/authentication/police/sign-in";
import PoliceDashboard from "layouts/policeLayouts/dashboard";
import TenantVerification from "layouts/policeLayouts/tenantVerification";
import PoliceProfile from "layouts/policeLayouts//profile";
import ChangePassword from "layouts/policeLayouts/change-password";

// @mui icons
import Icon from "@mui/material/Icon";
import FAQPage from "layouts/cmsPage/faqPage";
import WhyChooseUSPage from "layouts/cmsPage/whyChooseUSPage";
import Landlord from "layouts/landlord";
import Tenant from "layouts/tenant";

const adminRoutes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    type: "collapse",
    name: "Master",
    key: "master",
    icon: <Icon fontSize="small">dashboard</Icon>,
    collapse: [
      {
        type: "collapse",
        name: "State",
        key: "state",
        route: "/state",
        component: <StatePage />,
        icon: <Icon>location_city</Icon>,
      },
      {
        type: "collapse",
        name: "District",
        key: "district",
        icon: <Icon fontSize="small">location_city</Icon>,
        route: "/district",
        component: <DistrictPage />,
      },
      {
        type: "collapse",
        name: "City",
        key: "city",
        route: "/city",
        component: <CityPage />,
        icon: <Icon>location_city</Icon>,
      },
      {
        type: "collapse",
        name: "Location",
        key: "location",
        route: "/location",
        component: <LocationPage />,
        icon: <Icon>location_on</Icon>,
      },
      {
        type: "collapse",
        name: "Room Type",
        key: "room-type",
        icon: <Icon fontSize="small">location_city</Icon>,
        route: "/room-type",
        component: <RoomTypePage />,
      },
      {
        type: "collapse",
        name: "Category",
        key: "category",
        icon: <Icon fontSize="small">location_city</Icon>,
        route: "/category",
        component: <CategoryPage />,
      },
      {
        type: "collapse",
        name: "Banner",
        key: "banner",
        icon: <Icon fontSize="small">location_city</Icon>,
        route: "/banner",
        component: <BannerPage />,
      },
      {
        type: "collapse",
        name: "Advertisement",
        key: "advertisement",
        icon: <Icon fontSize="small">location_city</Icon>,
        route: "/advertisement",
        component: <AdvertisementPage />,
      },
    ],
  },
  {
    type: "collapse",
    name: "CMS",
    key: "cmsMaster",
    icon: <Icon fontSize="small">CMS</Icon>,
    collapse: [
      {
        type: "collapse",
        name: "CMS Content",
        key: "cms",
        icon: <Icon fontSize="small">ArticleIcon</Icon>,
        route: "/cms",
        component: <CmsContent />,
      },
      {
        type: "collapse",
        name: "FAQ",
        key: "faq",
        icon: <Icon fontSize="small">HelpOutlineIcon</Icon>,
        route: "/faq",
        component: <FAQPage />,
      },
      {
        type: "collapse",
        name: "Why Choose Us",
        key: "why-choose-us",
        icon: <Icon fontSize="small">InfoIcon</Icon>,
        route: "/why-choose-us",
        component: <WhyChooseUSPage />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Listings",
    key: "listing",
    icon: <Icon fontSize="small">ListIcon</Icon>,
    route: "/listing",
    component: <Listings />,
  },
  {
    type: "collapse",
    name: "Bookings",
    key: "bookings",
    icon: <Icon fontSize="small">LocalActivityIcon</Icon>,
    route: "/bookings",
    component: <Tables />,
  },
  {
    type: "collapse",
    name: "Franchise",
    key: "franchise",
    icon: <Icon fontSize="small">person_add</Icon>,
    route: "/franchise",
    component: <Franchise />,
  },
  {
    type: "collapse",
    name: "Landlord",
    key: "landlord",
    icon: <Icon fontSize="small">AdminPanelSettingsIcon</Icon>,
    route: "/landlord",
    component: <Landlord />,
  },
  {
    type: "collapse",
    name: "Tenant",
    key: "tenant",
    icon: <Icon fontSize="small">HomeIcon</Icon>,
    route: "/tenant",
    component: <Tenant />,
  },
  {
    type: "collapse",
    name: "Police Station",
    key: "police",
    icon: <Icon fontSize="small">person_add</Icon>,
    route: "/police",
    component: <Police />,
  },
  {
    type: "collapse",
    name: "Coupons",
    key: "coupons",
    icon: <Icon fontSize="small">Coupons</Icon>,
    route: "/coupons",
    component: <Coupons />,
  },
  {
    type: "collapse",
    name: "My Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <Profile />,
  },
];

const policeRoutes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "police-dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/police-dashboard",
    component: <PoliceDashboard />,
  },
  {
    type: "collapse",
    name: "Tenant Verification",
    key: "tenant-verification",
    icon: <Icon fontSize="small">verified_user</Icon>,
    route: "/tenant-verification",
    component: <TenantVerification />, // You'll need to create this component
  },
  {
    type: "collapse",
    name: "My Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <PoliceProfile />,
  },
  {
    type: "collapse",
    name: "Change Password",
    key: "change-password",
    icon: <Icon fontSize="small">lock</Icon>,
    route: "/change-password",
    component: <ChangePassword />,
  },
];

// Authentication routes (these will not be shown in navigation)
const authRoutes = [
  {
    key: "sign-in",
    route: "/sign-in",
    component: <SignIn />,
  },
  {
    key: "police-sign-in",
    route: "/police/sign-in",
    component: <PoliceSignIn />,
  },
];

// Export routes based on role
export { adminRoutes, policeRoutes, authRoutes };

// Default export for backward compatibility
export default adminRoutes;
